import styles from "./RadiologyResultDetails.module.css";

// Fallback shown only when the HL7 document can't be rendered via XSLT. The
// parsed results live in the main results component above, so here we keep just
// the patient summary.
export const RadiologyHL7DetailsTab = ({ loading, hl7Details }) => {
  if (loading || !hl7Details) {
    return (
      <div className={styles.emptyState}>
        <p className={styles.emptyStateTitle}>Loading radiology details...</p>
        <p className={styles.emptyStateText}>
          Please wait while we fetch the results.
        </p>
      </div>
    );
  }

  const { patientDemographics } = hl7Details;

  if (!patientDemographics) return null;

  const patientSummary = `${patientDemographics.address || ""} ${
    patientDemographics.mrn || ""
  } ${patientDemographics.patientName || ""} (${
    patientDemographics.dateOfBirth || ""
  } - ${patientDemographics.gender || ""})`;

  return (
    <div className={styles.hl7Container}>
      <div className={styles.hl7Section}>
        <h3 className={styles.hl7SectionTitle}>Patient Summary</h3>
        <p className={styles.patientSummaryText}>{patientSummary}</p>
      </div>
    </div>
  );
};
